import { useLayoutEffect, useRef, useState } from 'react';

interface PROPS {
  word: string;
  className?: string;
  style?: React.CSSProperties;
  px_per_second?: number;
  render_prefix?: () => React.ReactNode;
}

export function UI_PRIMITIVE__label_marquee({ word, className = '', style = {}, px_per_second = 30, render_prefix = () => null }: PROPS) {
  const ref_container = useRef<HTMLDivElement>(null);
  const ref_measure = useRef<HTMLSpanElement>(null);

  const [is_overflowing, set_is_overflowing] = useState(false);
  const [text_width, set_text_width] = useState(0);

  /*
   *
   */

  useLayoutEffect(() => {
    function update_overflow(): void {
      if (!ref_container.current || !ref_measure.current) return;

      const scroll_width = ref_measure.current.scrollWidth;
      const client_width = ref_container.current.clientWidth;

      set_is_overflowing(scroll_width > client_width);
    }

    update_overflow();

    const resize_observer = new ResizeObserver(update_overflow);
    if (ref_container.current) {
      resize_observer.observe(ref_container.current);
    }

    return () => resize_observer.disconnect();
  }, [word]);

  useLayoutEffect(() => {
    if (!ref_measure.current) return;
    set_text_width(ref_measure.current.scrollWidth);
  }, [word]);

  /*
   *
   */

  function get_marquee_duration_ms(width_px: number): number {
    const duration = (width_px / px_per_second) * 1000;
    return Math.min(Math.max(duration, 2000), 20_000);
  }

  /*
   *
   */

  const duration_ms = get_marquee_duration_ms(text_width);

  return (
    <div ref={ref_container} className="relative flex-1 min-w-0 overflow-hidden" style={style}>
      {/* Hidden measurement span */}
      <span ref={ref_measure} className="invisible absolute whitespace-nowrap pointer-events-none flex flex-row">
        {render_prefix()}
        {word}
      </span>

      {/* Overflow Marquee Animation */}
      {is_overflowing ? (
        <div className="token-marquee">
          <div
            className={`token-marquee-track ${className}`}
            style={
              {
                '--marquee-duration': `${duration_ms}ms`,
              } as React.CSSProperties
            }
          >
            {render_prefix()}
            <span>{word}</span>
            {render_prefix()}
            <span>{word}</span>
          </div>
        </div>
      ) : (
        /* Normal Truncated Text */
        <span className={`truncate block ${className}`}>
          {render_prefix()}
          {word}
        </span>
      )}
    </div>
  );
}
